import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { ADDRESS_NAME_MAX_LENGTH } from '../constants/addressNameLength';
import Disclaimer from '../disclaimer/Disclaimer';
import Input from '../input/Input';
import { CustomButton, ModalContent, Separator } from './styles';
const NewAddressContent = ({ value, buttonTitle, disclaimerText, inputPlaceholder, isValueInSavedAddresses, onButtonClick, setChecked, maxLengthErrText, alreadyExistText, inputPlaceHolder, }) => {
    const [addressName, setAddressName] = useState('');
    const submitAddress = () => {
        setChecked(true);
        onButtonClick?.(addressName);
    };
    const isFormValid = addressName.length < 1 ||
        addressName.length > ADDRESS_NAME_MAX_LENGTH ||
        isValueInSavedAddresses;
    const inputErrorMessage = addressName.length > ADDRESS_NAME_MAX_LENGTH ? maxLengthErrText : '';
    return (_jsxs(ModalContent, { children: [_jsx(Input, { disabled: true, value: value, placeholder: inputPlaceholder, errorMessage: isValueInSavedAddresses ? alreadyExistText : '' }), _jsx(Separator, {}), _jsx(Input, { errorMessage: inputErrorMessage, value: addressName, onChangeText: setAddressName, disabled: isValueInSavedAddresses, placeholder: inputPlaceHolder }), _jsx(Separator, {}), !!disclaimerText && (_jsxs(_Fragment, { children: [_jsx(Disclaimer, { description: disclaimerText }), _jsx(Separator, {})] })), _jsx(CustomButton, { title: buttonTitle, onClick: submitAddress, disabled: isFormValid })] }));
};
export default NewAddressContent;
//# sourceMappingURL=NewAddressContent.js.map